var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Коммерческие условия'),  path: `/commercialTerms`,  icon: 'vip_icon icon_policy'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }